import './CreateEditCourseModal.scss';
import {i18n} from "../../../Utils/i18n/i18n";
import {FormInput} from "../../Form/Input/FormInput";
import React, {useState} from "react";
import {Button} from "../../Form/Button/Button";
import {buttonColors } from "../../Pickers/InputTheme";
import {
    SA_createSignDoc,
    SA_getAllCompanies,
    SA_uploadSignDocZipFileAPI,
    SA_addSignDocToAllOrganizationsOfCompany
} from "../../../Services/SA_api";
import {FileUploadBox} from "../../Smart/FileUploadBox/FileUploadBox";
import {cloneDeep, get, map} from "lodash";
import {Modal} from "../../Smart/Modal/Modal";
import {imageOptionsArray} from "./CreateEditCourseLib";
import {ImageSelectGallery} from "./ImageSelectGallery/ImageSelectGallery";
import {SignDocTypes} from "../../SignDoc/SignDocLib";
import {MultiSelectAutocomplete} from "../../Form/AutoComplete/AutoComplete";

const imageOptions = cloneDeep(imageOptionsArray)

export const CreateNewCourseModal = ({createCourseModalOpen, closeCreateCourseModal}) => {
    const [docName, setDocName] = useState()
    const [courseDescription, setCourseDescription] = useState()
    const [signDocId, setSignDocId] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const [companies, setCompanies] = useState()
    const [selectedCompany, setSelectedCompany] = useState(null)
    const [zipFileUploaded, setZipFileUploaded] = useState(false)
    const [selectedImageUrl, setSelectedImageUrl] = useState(imageOptions[0])
    const editCourseName = (e) => {
        setDocName(e.target.value)
    }
    const editCourseDescription = (e) => {
        setCourseDescription(e.target.value)
    }

    /**
     * Handles company selection change from MultiSelectAutocomplete (single select mode)
     * @param {object} selected - Selected company object {value, text}
     */
    const onCompanySelectionChange = (selected) => {
        setSelectedCompany(selected)
    }

    /**
     * Fetches companies for the autocomplete dropdown with search
     * @param {object} params - Fetch params
     * @param {string} params.query - Search query
     * @returns {Promise<Array>} Array of company options
     */
    const fetchCompanyOptions = async ({ query }) => {
        if (!companies) return [];

        // Filter companies based on query
        if (!query || query.trim() === '') {
            return companies;
        }

        const queryLower = query.toLowerCase().trim();
        return companies.filter(company =>
            company.text.toLowerCase().includes(queryLower)
        );
    }
    const onCreateCourse = async () => {
        setIsLoading(true)
        const [newSignDoc, companiesData] = await Promise.all([SA_createSignDoc({
            docName,
            description: courseDescription,
            imgSrc: selectedImageUrl,
            type: SignDocTypes.REGULAR_COURSE
        }), SA_getAllCompanies()])
        const companyOptions = map(companiesData, (company) => {
            return {
                value: get(company, 'id'),
                text: get(company, 'companyName')
            }
        })
        setCompanies(companyOptions)
        setSelectedCompany(null)
        setSignDocId(newSignDoc.id)
        setDocName(newSignDoc.docName)
        setCourseDescription(newSignDoc.description)
        setIsLoading(false)
    }

    const onAssignToOrganizations = async () => {
        if (!selectedCompany) return
        setIsLoading(true)
        await SA_addSignDocToAllOrganizationsOfCompany({signDocId: signDocId, companyId: selectedCompany.value})
        setIsLoading(false)
        closeCreateCourseModal()
    }

    const uploadCourseZip = async ({files, onProgress}) => {
        return SA_uploadSignDocZipFileAPI({files, onProgress, signDocId})
    }

    const onZipFileCompletedUpload = () => {
        setZipFileUploaded(true)
    }

    const onSelectedImageUrl = (imageUrl) => () => {
        setSelectedImageUrl(imageUrl)
    }

    return <Modal
        open={createCourseModalOpen}
        onClose={closeCreateCourseModal}>
        <div className="CreateEditCourse modalWrapper">
            <div className="modalTitle">{i18n.translate('superAdmin.createNewCourse.modalTitle')}</div>
            <div className="modalContent">
                <div className="upperRow">
                    <div className="courseDetails">
                        <FormInput
                            label={i18n.translate('superAdmin.createNewCourse.docName')}
                            className=""
                            value={docName}
                            onChange={editCourseName}
                        />
                        <FormInput
                            label={i18n.translate('superAdmin.createNewCourse.courseDescription')}
                            className=""
                            value={courseDescription}
                            onChange={editCourseDescription}
                        />



                    </div>

                    {signDocId ? <div className={`courseZipFile`}>
                        <FileUploadBox uploadFiles={uploadCourseZip} onFileUploaded={onZipFileCompletedUpload} maxSize={600 * 1024 * 1024}>
                            {i18n.translate('superAdmin.createNewCourse.dropZipHere')}
                        </FileUploadBox>
                    </div> : ''}
                </div>
                <ImageSelectGallery selectedImageUrl={selectedImageUrl} onSelectedImageUrl={onSelectedImageUrl} imageOptions={imageOptions}/>
                {!signDocId ? <div className="saveContainer">
                    <Button
                        color={buttonColors.GREY}
                        onClick={onCreateCourse}
                        disabled={docName === '' || !docName || courseDescription === '' || !courseDescription}
                        text={i18n.translate('superAdmin.createNewCourse.create')}
                    />
                </div> : ''}
                {signDocId && companies ? (
                    <div className="companySelectionContainer">
                        <div className="companySelectWrapper">
                            <MultiSelectAutocomplete
                                fetchOptions={fetchCompanyOptions}
                                onSelectionChange={onCompanySelectionChange}
                                isSingleSelect={true}
                                initialSelectedValues={selectedCompany}
                                label={i18n.translate('superAdmin.assets.columns.company')}
                            />
                        </div>
                        <div className="assignButtonContainer">
                            <Button
                                color={buttonColors.GREY}
                                onClick={onAssignToOrganizations}
                                disabled={isLoading || !selectedCompany}
                                text={i18n.translate('superAdmin.createNewCourse.assignToAllOrganizations')}
                            />
                        </div>
                    </div>
                ) : ''}
            </div>
            <div className="modalFooter">
                <Button
                    color={buttonColors.YELLOW}
                    onClick={closeCreateCourseModal}
                    text={i18n.translate('general.close')}
                />
            </div>
        </div>
    </Modal>
}